const InvalidSession = ({ returnPage }) => {
  return (
    <div className="py-8 text-center">
        <h2 className="text-2xl mb-4">Enlace no disponible</h2>
        <p className="text-gray-600 mb-6">
            El recurso dejó de estar disponible. Vuelve a generar una nueva URL para restablecer tu contraseña.
        </p>
        <button
            type="button"
            onClick={returnPage}
            className="w-full text-white text-xs py-2 transition border border-transparent
                bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
        >
            Volver al inicio de sesión
        </button>
    </div>
  );
};

export default InvalidSession;
